import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { ENV } from '../config';

let bugsnagClient: ReturnType<typeof Bugsnag.start> | null = null;

export function initBugsnag() {
  const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY;
  const disableBugsnag = import.meta.env.DEV;

  if (!apiKey || disableBugsnag) {
    return null;
  }

  if (bugsnagClient) {
    return bugsnagClient;
  }

  bugsnagClient = Bugsnag.start({
    apiKey,
    appVersion: __APP_VERSION__,
    releaseStage: ENV,
    plugins: [new BugsnagPluginReact()],
  });

  return bugsnagClient;
}

export function getBugsnagClient() {
  return bugsnagClient;
}
